<template>
  <div v-if="!page.deleted" class="page-preview">
    <div v-if="isImage" :class="`reg-page-preview-item ${rotateClassName}`">
      <v-btn class="fullscreen-icon reg-btn-lower px-2"
             outlined
             color="primary"
             @click="onOpenPage">
        <v-icon>
          mdi-fullscreen
        </v-icon>
        Tela cheia
      </v-btn>
      <v-btn v-if="showDelete"
             class="delete-icon px-2"
             outlined
             icon
             color="error"
             @click.stop="onDeletePage">
        <v-icon>
          mdi-delete-outline
        </v-icon>
      </v-btn>
      <v-btn class="rotate-icon px-2"
             outlined
             icon
             color="primary"
             @click.stop="onRotateRight">
        <v-icon>
          mdi-rotate-right
        </v-icon>
      </v-btn>
      <reg-zoom-image v-if="page.signedKey"
                      class="pr-2"
                      :max-image-width="page.width"
                      :max-image-height="page.height"
                      :container-width="200"
                      :container-height="250"
                      :rotation="page.rotation"
                      :src="page.signedKey" />
    </div>
    <v-btn v-else
           class="page-btn"
           outlined
           color="primary"
           @click="onPageClick">
      Download
    </v-btn>
  </div>
</template>

<script>
import DownloadMixin from '~mixins/DownloadMixin'
import ZoomImage from '~shared/ZoomImage.vue'

export default {
  name: 'RegDocumentPageItemPreview',
  components: {
    'reg-zoom-image': ZoomImage
  },
  mixins: [DownloadMixin],
  props: {
    docTypeName: {
      type: String,
      default: ''
    },
    page: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isImage() {
      return String(this.page.type).startsWith('image/')
    },
    rotateClassName() {
      return `${this.page.rotation ? 'rotate-image-' + this.page.rotation : ''}`
    }
  },
  methods: {
    onPageClick() {
      this.downloadFileFromS3(this.page, this.page.customName)
    },
    onRotateRight() {
      const rotation = this.page.rotation === 270 ? 0 : (this.page.rotation || 0) + 90
      this.$emit('rotate', { id: this.page.id, rotation })
    },
    onOpenPage() {
      this.$emit('click', this.page)
    },
    onDeletePage() {
      this.$emit('delete', this.page)
    }
  }
}
</script>
<style lang="scss">
.reg-page-preview-item {
  position: relative;
  max-height: 250px;
  max-width: 100%;
  min-width: 50px;
  padding: 0;
  margin: 10px;
  .page-btn {
    z-index: 100;
    position: absolute;
    height: 56px;
    width: 50px;
    min-width: 50px;
    padding: 0px;
    margin: 0px;
  }
  .fullscreen-icon {
    z-index: 200;
    position: absolute;
    bottom: -10px;
    left: -10px;
    margin: 0;
    padding: 0;
    height: 30px;
    border-radius: 10px;
    min-width: 30px;
    background-color: white !important;
    i {
      font-size: 18px !important;
    }
  }
  .rotate-icon {
    z-index: 200;
    position: absolute;
    top: -10px;
    right: -5px;
    margin: 0;
    padding: 0;
    height: 30px;
    border-radius: 30px;
    max-width: 30px;
    background-color: white !important;
    i {
      font-size: 22px !important;
    }
  }

  .delete-icon {
    z-index: 200;
    position: absolute;
    top: -10px;
    right: 30px;
    margin: 0;
    padding: 0;
    height: 30px;
    border-radius: 30px;
    max-width: 30px;
    background-color: white !important;
    i {
      font-size: 22px !important;
    }
  }
}

</style>
